import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        
        <p className="copyright">© 2026, OPOS, Inc. All Rights Reserved</p>
      </div>
    </footer>
  );
}